<div class="bg-white rounded-[20px] border border-[#E7EAF0] p-3 mb-4 shadow-sm">
    <!-- Header -->
    <div class="flex justify-between items-start">
        <div class="flex space-x-2">
            <!-- Avatar -->
            <ngx-skeleton-loader appearance="square" [theme]="{ width: '48px', height: '48px' }"></ngx-skeleton-loader>

            <div class="flex flex-col space-y-2 mt-2">
                <!-- Name -->
                <ngx-skeleton-loader class="w-28 h-4 rounded-md"></ngx-skeleton-loader>

                <!-- Member Count -->
                <ngx-skeleton-loader class="w-20 h-3 rounded-md"></ngx-skeleton-loader>
            </div>
        </div>

        <ngx-skeleton-loader class="w-12 h-3 mt-2" [theme]="{ borderRadius: '999px' }"></ngx-skeleton-loader>
    </div>
</div>
